import React, {Component, Fragment} from "react";
import {
    Table,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import Moment from 'react-moment';
import * as common from "../../lib/common";

const headerStyle = {
    padding: '0.5rem',
};
class OrderHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            refs: {}
        }
    }
    closeTabHandle = () => {
        this.setState({refs: {}}, this.props.onClose)
    }
    // build ref object with collapsible elements ids
    setRef = (element) => {
        if (!element) {
            return
        }
        let {refs} = this.state
        refs[element.id] = element
        this.setState({refs})
    }
    // toggle "show" CSS class using plain JS
    collapseRef = (id) => {
        const {refs} = this.state
        for(const propertyName in refs) {
            if (propertyName != id) {
                refs[propertyName].classList.remove('show')
            }
        }
        refs[id].classList.toggle('show')
    }
    render() {
        const {
            orderHistory,
            isRequesting,
        } = this.props
        const getName = (item) => {
            return (
              <Fragment>
                  <div>
                      <span className={"text-primary font-weight-bold"}>{item.Ma}/{item.Ten}</span>
                  </div>
                  <div className={"text-muted"}>{item.DiaChi}</div>
              </Fragment>
            )
        }
        const renderLogItem = (jsonData) => {
            const items = JSON.parse(jsonData)
            if (items.length == 0) {
                return null
            }
            const trs = items.map((x, index) => {
                return (
                  <tr key={index}>
                      <td>{x.sku}/{x.tenthuoc}</td>
                      <td>{x.soluong}/ {x.tendvtban}</td>
                  </tr>
                )
            })
            return (
              <Table hover responsive className="table-outline table-sm mb-0 d-sm-table table table-hover">
                  <thead>
                      <tr>
                          <th>Tên</th>
                          <th>Số lượng</th>
                      </tr>
                  </thead>
                  <tbody>
                    {trs}
                  </tbody>
              </Table>
            )
        }
        return (
            <div className="animated fadeIn">
                <Modal isOpen={this.props.isOpen} className={'modal-lg ' + this.props.className}>
                    <ModalHeader style={headerStyle}>
                        LỊCH SỬ ĐƠN HÀNG
                    </ModalHeader>
                    <ModalBody>
                        <BlockUi tag="div" blocking={isRequesting}>
                            <Table hover responsive className="table-outline table-sm mb-0 d-sm-table table table-hover">
                                <thead className="thead-default">
                                    <tr>
                                        <th scope="col" width="40" className="text-center">#</th>
                                        <th scope="col" className="text-left">Ngày</th>
                                        <th scope="col" className="text-left">Nhà thuốc</th>
                                        <th scope="col" className="text-center">Trạng thái</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orderHistory && !!orderHistory.length && (
                                        orderHistory.map((res, idx) => (
                                            <Fragment key={idx + 1}>
                                                <tr>
                                                    <td className="text-center">{idx + 1}</td>
                                                    <td className="text-left">
                                                        {res.NgayTao && (
                                                          <Moment format="HH:mm DD/MM/YYYY">{`${res.NgayTao}`}</Moment>
                                                        )}
                                                    </td>
                                                    <td className="text-left">{getName(res)}</td>
                                                    <td className="text-center">
                                                        <div>
                                                            {common.getCustomerMarketingReceiveStatusText(res.Status, true)}
                                                        </div>
                                                        <div>
                                                            <button
                                                              type={"button"}
                                                              onClick={() => this.collapseRef(`dataJson_${idx}`)}
                                                              className={"btn btn-link"}
                                                            >
                                                                <i className={"fa fa-arrow-down"}></i>Xem
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr className="collapse" ref={this.setRef} id={`dataJson_${idx}`}>
                                                    <td></td>
                                                    <td colSpan={3}>
                                                        {renderLogItem(res.JsonData)}
                                                    </td>
                                                </tr>
                                            </Fragment>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        </BlockUi>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.closeTabHandle.bind(this)}><i className="fa fa-close"></i>&nbsp;Đóng</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}
export default OrderHistory


// WEBPACK FOOTER //
// ./src/views/MarketingOrder/_OrderHistory.js